import ClockSticker from "../images/SmallProjects/13ClockFace.jpeg";
import Pillow from "../images/SmallProjects/Pillow.jpeg";
import Lamp from "../images/SmallProjects/Lamp.jpeg";
import Triforce1 from "../images/SmallProjects/Triforce Digital Design.jpeg";
import Triforce2 from "../images/SmallProjects/Triforce Container Digital Design.jpeg";
import DogCont from "../images/SmallProjects/Container Digital Design.jpeg";
import PrintedItems from "../images/SmallProjects/Early 3D Prints.jpeg";


const SmallProjects = [
  {
    src: ClockSticker,
    text: "The sticker was designed and cut on a vinyl printer by me in GoCreate at WSU. The clock face was used in the Fairy Door Project."
  },
  {
    src: Pillow,
    text: "We were tasked with learning to use sewing machines to create two pillow slip covers with zippers."
  },
  {
    src: Lamp,
    text: "I wired and designed this lamp from a project I found on Pinterest using wooden embroidery hoops."
  },
  {
    src: Triforce1,
    text: "As a Zelda fan, my first 3D print was the Triforce, naturally. This was designed using Fusion360."
  },
  {
    src: Triforce2,
    text: "I also designed a Triforce container or trinket shelf that never got printed. Also designed using Fusion360."
  },
  {
    src: DogCont,
    text: "I also designed a small container to hold dog treats using Fusion360."
  },
  {
    src: PrintedItems,
    text: "These are the pieces I ended up getting to print using the GoCreate 3D printers."
  }
]

export default SmallProjects;